import { DEFAULT_LANGUAGE } from '../../i18n';

const LEGAL_CONTENT = {
  it: {
    privacy: {
      title: 'Privacy Policy',
      updated: '1 marzo 2025',
      summary:
        'Questa informativa descrive come Loopino raccoglie, usa e protegge i dati personali quando utilizzi la piattaforma.',
      sections: [
        {
          title: '1. Titolare del trattamento',
          paragraphs: [
            'Il titolare del trattamento e\' Loopino (di seguito "Loopino").',
            'Per qualsiasi richiesta puoi scrivere a support@loopino.com.'
          ]
        },
        {
          title: '2. Dati raccolti',
          paragraphs: [
            'Trattiamo i dati necessari per fornire il servizio e migliorarlo.'
          ],
          bullets: [
            'Dati account: nome, email, username, lingua e preferenze.',
            'Dati di utilizzo: log tecnici, eventi di navigazione, performance.',
            'Contenuti caricati o generati: testi, immagini, asset e metadati.',
            'Dati di pagamento gestiti tramite provider esterni (es. Stripe).'
          ]
        },
        {
          title: '3. Finalita e basi giuridiche',
          bullets: [
            'Erogare il servizio e gestire il rapporto contrattuale.',
            'Assistenza clienti e comunicazioni operative.',
            'Sicurezza, prevenzione abusi e tutela della piattaforma.',
            'Analisi aggregate per migliorare funzionalita e performance.'
          ]
        },
        {
          title: '4. Condivisione dei dati',
          paragraphs: [
            'Condividiamo i dati solo con fornitori che ci supportano nell\'erogazione del servizio (hosting, analytics, pagamenti, assistenza) e con obblighi legali.'
          ]
        },
        {
          title: '5. Conservazione',
          paragraphs: [
            'Conserviamo i dati per il tempo necessario a fornire il servizio e rispettare obblighi legali o di sicurezza. I contenuti possono essere rimossi su richiesta nei limiti previsti.'
          ]
        },
        {
          title: '6. Diritti degli interessati',
          bullets: [
            'Accedere ai tuoi dati e ottenerne copia.',
            'Chiedere rettifica o cancellazione.',
            'Limitare o opporti al trattamento.',
            'Portabilita dei dati nei casi previsti.'
          ]
        },
        {
          title: '7. Trasferimenti internazionali',
          paragraphs: [
            'Alcuni fornitori possono trattare dati fuori dallo Spazio Economico Europeo. In tali casi adottiamo garanzie adeguate previste dalla normativa.'
          ]
        },
        {
          title: '8. Aggiornamenti',
          paragraphs: [
            'Possiamo aggiornare questa informativa periodicamente. Le modifiche saranno pubblicate in questa pagina.'
          ]
        }
      ]
    },
    terms: {
      title: 'Termini di Servizio',
      updated: '1 marzo 2025',
      summary:
        'Questi termini regolano l\'uso della piattaforma Loopino. Utilizzando il servizio accetti le condizioni riportate.',
      sections: [
        {
          title: '1. Accettazione dei termini',
          paragraphs: [
            'Accedendo o utilizzando la piattaforma dichiari di aver letto e accettato questi termini.'
          ]
        },
        {
          title: '2. Account e accesso',
          bullets: [
            'Sei responsabile della sicurezza delle credenziali.',
            'Devi fornire informazioni accurate e aggiornate.',
            'Loopino puo\' sospendere account in caso di violazioni.'
          ]
        },
        {
          title: '3. Piani e pagamenti',
          paragraphs: [
            'Alcune funzionalita richiedono un abbonamento. I pagamenti sono gestiti da provider esterni. Le condizioni commerciali sono indicate nei piani disponibili.'
          ]
        },
        {
          title: '4. Uso consentito',
          bullets: [
            'Non usare il servizio per attivita illegali o dannose.',
            'Non caricare contenuti che violino diritti di terzi.',
            'Non tentare di compromettere la sicurezza della piattaforma.'
          ]
        },
        {
          title: '5. Contenuti e proprieta intellettuale',
          paragraphs: [
            'Mantieni la titolarita dei contenuti che carichi. Concedi a Loopino una licenza limitata per elaborarli e fornire il servizio.',
            'La piattaforma, i loghi e i materiali proprietari restano di proprieta di Loopino.'
          ]
        },
        {
          title: '6. Output AI',
          paragraphs: [
            'Gli output generati dall\'AI possono richiedere revisione. Sei responsabile dei contenuti pubblicati tramite la piattaforma.'
          ]
        },
        {
          title: '7. Disponibilita e modifiche',
          paragraphs: [
            'Loopino puo\' aggiornare, sospendere o modificare il servizio per motivi tecnici o evolutivi.'
          ]
        },
        {
          title: '8. Limitazioni di responsabilita',
          paragraphs: [
            'Nei limiti di legge, Loopino non e\' responsabile per danni indiretti, perdita di profitti o interruzioni del servizio.'
          ]
        },
        {
          title: '9. Legge applicabile',
          paragraphs: [
            'Questi termini sono regolati dalla legge italiana, salvo diversa disposizione inderogabile.'
          ]
        }
      ]
    },
    cookies: {
      title: 'Cookie Policy',
      updated: '1 marzo 2025',
      summary:
        'Questa pagina spiega come Loopino utilizza cookie e tecnologie simili.',
      sections: [
        {
          title: '1. Cosa sono i cookie',
          paragraphs: [
            'I cookie sono piccoli file di testo salvati sul tuo dispositivo per migliorare l\'esperienza di navigazione.'
          ]
        },
        {
          title: '2. Tipologie di cookie',
          bullets: [
            'Essenziali: necessari al funzionamento della piattaforma.',
            'Preferenze: memorizzano scelte come lingua o impostazioni.',
            'Analitici: aiutano a capire come viene utilizzato il servizio.'
          ]
        },
        {
          title: '3. Gestione dei cookie',
          paragraphs: [
            'Puoi gestire o bloccare i cookie tramite le impostazioni del browser. La disabilitazione di cookie essenziali puo\' limitare alcune funzionalita.'
          ]
        },
        {
          title: '4. Cookie di terze parti',
          paragraphs: [
            'Alcuni servizi esterni (es. analytics o pagamenti) possono impostare cookie propri secondo le rispettive informative.'
          ]
        },
        {
          title: '5. Aggiornamenti',
          paragraphs: [
            'Eventuali aggiornamenti della cookie policy saranno pubblicati su questa pagina.'
          ]
        }
      ]
    },
    notice: {
      title: 'Note legali',
      updated: '1 marzo 2025',
      summary:
        'Informazioni legali e di contatto relative alla piattaforma Loopino.',
      sections: [
        {
          title: '1. Editore del servizio',
          paragraphs: [
            'Loopino AI Platform e\' un servizio fornito da Loopino.',
            'Contatto: support@loopino.com.'
          ]
        },
        {
          title: '2. Proprieta intellettuale',
          paragraphs: [
            'Testi, marchi, loghi e grafiche sono protetti dalle leggi sulla proprieta intellettuale. E\' vietata la riproduzione non autorizzata.'
          ]
        },
        {
          title: '3. Hosting e infrastruttura',
          paragraphs: [
            'I dati possono essere ospitati su infrastrutture cloud selezionate per garantire affidabilita e sicurezza.'
          ]
        },
        {
          title: '4. Segnalazioni',
          paragraphs: [
            'Per comunicazioni ufficiali o segnalazioni puoi scrivere a support@loopino.com.'
          ]
        }
      ]
    }
  },
  en: {
    privacy: {
      title: 'Privacy Policy',
      updated: 'March 1, 2025',
      summary:
        'This notice explains how Loopino collects, uses, and protects personal data when you use the platform.',
      sections: [
        {
          title: '1. Data controller',
          paragraphs: [
            'The data controller is Loopino (the "Company").',
            'For any request, contact support@loopino.com.'
          ]
        },
        {
          title: '2. Data we process',
          paragraphs: [
            'We process the data needed to provide and improve the service.'
          ],
          bullets: [
            'Account data: name, email, username, language, preferences.',
            'Usage data: technical logs, navigation events, performance.',
            'Uploaded or generated content: text, images, assets, metadata.',
            'Payment data handled by external providers (e.g. Stripe).'
          ]
        },
        {
          title: '3. Purposes and legal bases',
          bullets: [
            'Provide the service and manage the contractual relationship.',
            'Customer support and operational communications.',
            'Security, abuse prevention, and platform protection.',
            'Aggregate analytics to improve features and performance.'
          ]
        },
        {
          title: '4. Data sharing',
          paragraphs: [
            'We share data only with vendors that help us deliver the service (hosting, analytics, payments, support) and when required by law.'
          ]
        },
        {
          title: '5. Retention',
          paragraphs: [
            'We keep data for as long as needed to provide the service and comply with legal or security obligations. Content can be removed on request where applicable.'
          ]
        },
        {
          title: '6. Your rights',
          bullets: [
            'Access your data and obtain a copy.',
            'Request correction or deletion.',
            'Restrict or object to processing.',
            'Data portability where applicable.'
          ]
        },
        {
          title: '7. International transfers',
          paragraphs: [
            'Some vendors may process data outside the EEA. We adopt appropriate safeguards as required by law.'
          ]
        },
        {
          title: '8. Updates',
          paragraphs: [
            'We may update this notice from time to time. Changes will be published on this page.'
          ]
        }
      ]
    },
    terms: {
      title: 'Terms of Service',
      updated: 'March 1, 2025',
      summary:
        'These terms govern your use of the Loopino platform. By using the service you accept them.',
      sections: [
        {
          title: '1. Acceptance of terms',
          paragraphs: [
            'By accessing or using the platform, you confirm that you have read and accepted these terms.'
          ]
        },
        {
          title: '2. Account and access',
          bullets: [
            'You are responsible for keeping credentials secure.',
            'You must provide accurate and up-to-date information.',
            'Loopino may suspend accounts for violations.'
          ]
        },
        {
          title: '3. Plans and payments',
          paragraphs: [
            'Some features require a subscription. Payments are handled by external providers. Commercial terms are described in the available plans.'
          ]
        },
        {
          title: '4. Acceptable use',
          bullets: [
            'Do not use the service for illegal or harmful activities.',
            'Do not upload content that violates third-party rights.',
            'Do not attempt to compromise platform security.'
          ]
        },
        {
          title: '5. Content and intellectual property',
          paragraphs: [
            'You retain ownership of your uploaded content. You grant Loopino a limited license to process it and provide the service.',
            'The platform, logos, and proprietary materials remain Loopino property.'
          ]
        },
        {
          title: '6. AI outputs',
          paragraphs: [
            'AI-generated outputs may require review. You are responsible for the content published through the platform.'
          ]
        },
        {
          title: '7. Availability and changes',
          paragraphs: [
            'Loopino may update, suspend, or modify the service for technical or operational reasons.'
          ]
        },
        {
          title: '8. Limitation of liability',
          paragraphs: [
            'To the extent permitted by law, Loopino is not liable for indirect damages, loss of profits, or service interruptions.'
          ]
        },
        {
          title: '9. Governing law',
          paragraphs: [
            'These terms are governed by Italian law unless mandatory rules provide otherwise.'
          ]
        }
      ]
    },
    cookies: {
      title: 'Cookie Policy',
      updated: 'March 1, 2025',
      summary:
        'This page explains how Loopino uses cookies and similar technologies.',
      sections: [
        {
          title: '1. What cookies are',
          paragraphs: [
            'Cookies are small text files stored on your device to improve navigation.'
          ]
        },
        {
          title: '2. Types of cookies',
          bullets: [
            'Essential: required for the platform to function.',
            'Preferences: remember choices such as language or settings.',
            'Analytics: help us understand how the service is used.'
          ]
        },
        {
          title: '3. Managing cookies',
          paragraphs: [
            'You can manage or block cookies via browser settings. Disabling essential cookies may limit functionality.'
          ]
        },
        {
          title: '4. Third-party cookies',
          paragraphs: [
            'Some external services (e.g. analytics or payments) may set their own cookies according to their policies.'
          ]
        },
        {
          title: '5. Updates',
          paragraphs: [
            'Any updates to this cookie policy will be published on this page.'
          ]
        }
      ]
    },
    notice: {
      title: 'Legal Notice',
      updated: 'March 1, 2025',
      summary:
        'Legal and contact information related to the Loopino platform.',
      sections: [
        {
          title: '1. Service publisher',
          paragraphs: [
            'Loopino AI Platform is provided by Loopino.',
            'Contact: support@loopino.com.'
          ]
        },
        {
          title: '2. Intellectual property',
          paragraphs: [
            'Texts, trademarks, logos, and graphics are protected by intellectual property laws. Unauthorized use is prohibited.'
          ]
        },
        {
          title: '3. Hosting and infrastructure',
          paragraphs: [
            'Data may be hosted on cloud infrastructure selected for reliability and security.'
          ]
        },
        {
          title: '4. Notices',
          paragraphs: [
            'For official communications or notices, contact support@loopino.com.'
          ]
        }
      ]
    }
  }
};

const normalizeLanguage = (language) => {
  if (!language) return DEFAULT_LANGUAGE;
  const normalized = language.toLowerCase().split('-')[0];
  return LEGAL_CONTENT[normalized] ? normalized : DEFAULT_LANGUAGE;
};

export const getLegalContent = (language, key) => {
  const locale = normalizeLanguage(language);
  const fallbackLocale = normalizeLanguage(DEFAULT_LANGUAGE);
  const pageKey = key && LEGAL_CONTENT[locale]?.[key] ? key : 'privacy';

  return LEGAL_CONTENT[locale]?.[pageKey] || LEGAL_CONTENT[fallbackLocale]?.privacy;
};

export default LEGAL_CONTENT;
